// Messages for operator/Announcements (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.announcements.head': 'Announcements — Operator',
  'operator.announcements.title': 'Announcements',
  'operator.announcements.desc': 'Broadcast a banner to all customers or to one company.',
  'operator.announcements.title_label': 'Title',
  'operator.announcements.title_error': 'Title {error}',
  'operator.announcements.body': 'Body',
  'operator.announcements.type': 'Type',
  'operator.announcements.type_aria': 'Announcement type',
  'operator.announcements.info': 'Info',
  'operator.announcements.maintenance': 'Maintenance',
  'operator.announcements.warning': 'Warning',
  'operator.announcements.audience': 'Audience',
  'operator.announcements.audience_aria': 'Announcement audience',
  'operator.announcements.all_customers': 'All customers',
  'operator.announcements.expires_label': 'Expires (optional)',
  'operator.announcements.expires_hint':
    'Leave blank to keep it up until unpublished. It hides itself once this time passes.',
  'operator.announcements.expires_at': 'expires {when}',
  'operator.announcements.publish': 'Publish',
  'operator.announcements.published': 'Published',
  'operator.announcements.one_company': 'One company',
  'operator.announcements.all': 'All',
  'operator.announcements.active': 'active',
  'operator.announcements.inactive': 'inactive',
  'operator.announcements.unpublish': 'Unpublish',
  'operator.announcements.republish': 'Publish',
  'operator.announcements.remove': 'Remove',
  'operator.announcements.remove_confirm': 'Remove this announcement permanently?',
  'operator.announcements.empty': 'No announcements yet.',
}

export const zhTW = {
  'operator.announcements.head': '公告 — 操作員',
  'operator.announcements.title': '公告',
  'operator.announcements.desc': '向所有客戶或單一公司廣播橫幅。',
  'operator.announcements.title_label': '標題',
  'operator.announcements.title_error': '標題{error}',
  'operator.announcements.body': '內文',
  'operator.announcements.type': '類型',
  'operator.announcements.type_aria': '公告類型',
  'operator.announcements.info': '資訊',
  'operator.announcements.maintenance': '維護',
  'operator.announcements.warning': '警告',
  'operator.announcements.audience': '對象',
  'operator.announcements.audience_aria': '公告對象',
  'operator.announcements.all_customers': '所有客戶',
  'operator.announcements.expires_label': '到期時間（選填）',
  'operator.announcements.expires_hint': '留空則持續顯示直到取消發布。超過此時間後會自動隱藏。',
  'operator.announcements.expires_at': '到期 {when}',
  'operator.announcements.publish': '發布',
  'operator.announcements.published': '已發布',
  'operator.announcements.one_company': '單一公司',
  'operator.announcements.all': '全部',
  'operator.announcements.active': '生效中',
  'operator.announcements.inactive': '未生效',
  'operator.announcements.unpublish': '取消發布',
  'operator.announcements.republish': '發布',
  'operator.announcements.remove': '移除',
  'operator.announcements.remove_confirm': '永久移除此公告？',
  'operator.announcements.empty': '尚無公告。',
}
